import React from 'react'
import {Icon} from '@chakra-ui/react'

const RefreshIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 25" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.8821 6.07421H15.876V8.10961H21.9822V2.00342H19.9468V4.24726C15.912 0.249998 10.4307 -0.0191875 6.10547 3.23135L7.32829 4.85847C10.9755 2.11753 15.5255 2.42282 18.8821 6.07421ZM9.31517 21.2321L10.2254 19.4116C5.53384 17.0658 3.95131 13.4198 5.10202 8.33116L6.92035 10.7556L8.54867 9.53437L4.88496 4.64941L0 8.31313L1.22124 9.94145L2.96671 8.63235C1.95067 14.2332 3.95462 18.5518 9.31517 21.2321ZM15.4287 21.0038L17.5047 22.5608L16.2835 24.1891L11.5332 20.6264L13.9484 15.7959L15.769 16.7062L14.5562 19.1317C18.7763 18.0419 20.965 14.4845 20.965 10.145H23.0004C23.0004 15.2255 20.3951 19.5588 15.4287 21.0038Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default RefreshIcon
